<div class="row mx-4">
    <div
        *ngFor="let item of shoppingCartItems"
        class="row cart-item"
    >
        <div class="col-md-3 col-lg-2 d-none d-md-block p-2 text-center">
            <img
                [src]="item.imageUrl"
                alt="cart-item-img"
            />
        </div>
        <div class="col-md-7 col-lg-8 item-description p-2">
            <p><strong>{{item.productName}}</strong></p>
            <div *ngIf="item.shortDescription"><span [innerHTML]="item.shortDescription | safe: 'html'"></span></div>
            <div *ngIf="item.description"><span [innerHTML]="item.description | safe: 'html'"></span></div>
            <div
                *ngIf="item.promotion"
                class="price-discount"
            >You are eligible for <b>{{ item.promotion.code }}</b> - {{ item.promotion.description }}
            </div>
            <div *ngIf="item.maxQuantity == null || item.maxQuantity > 1">
                <app-item-quantity
                    [currencyCode]="shoppingCart.currencyCode"
                    [item]="item"
                ></app-item-quantity>
            </div>
            <div class="d-md-none">
                <br />
                <span>{{(shoppingCart.isAllInclusivePrice ? item.total : item.subTotal) | currency : shoppingCart.currencyCode : shoppingCart.currencyCode + " " }}</span>
                <button
                    type="button"
                    class="btn btn-sm"
                    (click)="onModalLoad(item.id)"
                >
                    <i class="fa fa-trash"></i> Remove
                </button>
                <span
                    class="price-discount"
                    *ngIf="item.discountAmount > 0 || item.originalPrice > item.price"
                >You saved: {{ (item.originalPrice* item.quantity - item.subTotal) | currency: shoppingCart.currencyCode : shoppingCart.currencyCode + " " }}</span>
            </div>
        </div>
        <div class="col-md-2 d-none d-md-block total-price p-2">
            <div *ngIf="item.originalPrice > item.price"><del style="color:#A6192E">{{(shoppingCart.isAllInclusivePrice ? item.priceAllInclusive * item.quantity : item.originalPrice * item.quantity) | currency : shoppingCart.currencyCode :shoppingCart.currencyCode + " " }}</del></div>
            <p class="text-center">{{ (shoppingCart.isAllInclusivePrice ? item.total : item.subTotal) | currency : shoppingCart.currencyCode : shoppingCart.currencyCode + " "}}</p>
            <button
                type="button"
                class="btn btn-sm"
                (click)="onModalLoad(item.id)"
            >
                <i class="fa fa-trash"></i> Remove
            </button>
            <span
                class="price-discount"
                *ngIf="
                      item.discountAmount
                  > 0 || item.originalPrice > item.price"
            >You saved: {{(shoppingCart.isAllInclusivePrice ? item.priceAllInclusive * item.quantity - item.total : item.originalPrice* item.quantity - item.subTotal) | currency: shoppingCart.currencyCode: shoppingCart.currencyCode + " "}}</span>
        </div>
    </div>
    <div class="cart-subtotal">
        <p>Cart Subtotal: <strong>{{ (shoppingCart.isAllInclusivePrice ? shoppingCart.total : (shoppingCart.subTotal - shoppingCart.shippingAndHandlingFee))  | currency: shoppingCart.currencyCode: shoppingCart.currencyCode + " "}}</strong></p>
    </div>
</div>

<app-modal
    #confirmRemoveModal
    title="Removing Item"
    body="Are you sure you want to remove this item?"
    (clickPositive)="onRemove(itemIdToRemove)"
    isConfirm="true"
>
</app-modal>
